module.exports = __webpack_public_path__ + "static/dethek-alphabet-SCAG-9d8b3bdf161fcc6688108876b29e223b.jpg";